import React, {useEffect, useState} from "react";
import {BodyDropDown, ItemStyled} from "../../../styles/ContentViews";
import {LoadComponet} from "../../../components/loaders/Loader";
import Table from "../../../components/table/Tables";
import DeleteModal from "../../../components/modals/DeleteModal";
import ShowApplicantModal from "./ShowModal";

export default function ApplicantsTable({theme}) {
   const [isLoading, setIsLoading] = useState({data: true, view: false});
   const [data, setData] = useState([]);
   const [showApplicant, setShowApplicant] = useState({isOpen: false, data: {}});
   const [deleteApplicant, setDeleteApplicant] = useState({isOpen: false, id: "", url: ""});

   useEffect(() => {
      console.log(theme);
      getData();
   }, []);

   const getData = () => {
      let newData = [...DataApplicants];

      setData(newData);
      setTimeout(() => {
         setIsLoading({...isLoading, data: false});
      }, 500);
   };

   const removeId = id => {
      if (!IDBCursor) return false;
      let newAdminList = data.filter(item => item.id !== id);
      setData(newAdminList);
      setDeleteApplicant({isOpen: false, id: "", url: ""});
   };

   return (
      <>
         <BodyDropDown>
            <ItemStyled>
               {isLoading.data ? (
                  <LoadComponet isVisible={true} theme={theme} />
               ) : (
                  <Table
                     data={data}
                     columns={Columns}
                     theme={theme}
                     showModal={id => setShowApplicant({isOpen: true, data: data.find(item => item.id === id)})}
                     deleteModal={id => setDeleteApplicant({isOpen: true, id: id, url: "http://freeticket.trebolbit.com/api/city/list"})}
                  />
               )}
            </ItemStyled>
         </BodyDropDown>
         <ShowApplicantModal
            isOpen={showApplicant.isOpen}
            close={() => {
               setShowApplicant({isOpen: false, data: []});
            }}
            data={showApplicant.data}
            theme={theme}
         />
         <DeleteModal
            isOpen={deleteApplicant.isOpen}
            id={deleteApplicant.id}
            url={deleteApplicant.url}
            close={() => {
               setDeleteApplicant({isOpen: false, id: "", url: ""});
            }}
            theme={theme}
            save={removeId}
         />
      </>
   );
}

const Columns = [
   {
      title: "Nombre",
      accessor: "name",
      action: "show",
   },
   {
      title: "empresa",
      accessor: "company",
   },
   {
      title: "interés",
      accessor: "subject",
      width: "250px",
   },
   {
      title: "email",
      accessor: "email",
      // maxWidth: "180px",
   },
   {
      title: "teléfono",
      accessor: "phone",
   },
   {
      title: "",
      class: "actionBtn ghost",
      component: "delete",
   },
];

const DataApplicants = [
   {
      id: 0,
      name: "Ada",
      subject:
         "et in deserunt commodo reprehenderit nulla eiusmod occaecat nisi sunt veniam sint laboris ullamco culpa pariatur sit eiusmod do magna sunt duis",
      company: "Plexia",
      email: "adaneal@plexia.com",
      phone: "(863) 545-3155",
      date: "Sat Feb 08 2020 00:54:14 GMT-0600 (hora estándar central)",
   },
   {
      id: 1,
      name: "Monroe",
      subject:
         "veniam elit tempor adipisicing cillum elit dolore non officia irure nisi exercitation commodo aute sint in exercitation adipisicing tempor ipsum in nisi ad esse nisi consequat proident quis est eu nulla",
      company: "Ludak",
      email: "monroeneal@ludak.com",
      phone: "(939) 413-2242",
      date: "Wed Feb 05 2020 14:17:28 GMT-0600 (hora estándar central)",
   },
   {
      id: 2,
      name: "Maura",
      subject:
         "do cillum irure incididunt magna cupidatat velit tempor eiusmod do mollit occaecat exercitation veniam consequat minim Lorem cupidatat do tempor quis magna aute non non nostrud velit reprehenderit adipisicing consequat",
      company: "Irack",
      email: "mauraneal@irack.com",
      phone: "(912) 446-2835",
      date: "Thu Feb 13 2020 15:07:07 GMT-0600 (hora estándar central)",
   },
   {
      id: 3,
      name: "Laurel",
      subject:
         "consectetur culpa in nostrud mollit quis reprehenderit sint voluptate veniam ad occaecat laborum amet irure id deserunt nulla sint exercitation sit in excepteur",
      company: "Megall",
      email: "laurelneal@megall.com",
      phone: "(970) 568-2279",
      date: "Tue Jan 21 2020 12:57:17 GMT-0600 (hora estándar central)",
   },
   {
      id: 4,
      name: "Shelly",
      subject:
         "Lorem aliqua adipisicing aute deserunt laboris duis proident labore cupidatat Lorem proident ut occaecat qui ut quis magna duis velit excepteur veniam quis minim ullamco nostrud et est enim deserunt amet dolore nostrud labore nulla",
      company: "Diginetic",
      email: "shellyneal@diginetic.com",
      phone: "(967) 590-3707",
      date: "Mon Feb 24 2020 03:11:02 GMT-0600 (hora estándar central)",
   },
   {
      id: 5,
      name: "Earnestine",
      subject: "aliquip labore ut proident sunt Lorem deserunt esse cillum aute nulla aute nulla dolor sit mollit nisi cillum minim",
      company: "Obliq",
      email: "earnestineneal@obliq.com",
      phone: "(876) 425-3470",
      date: "Tue Mar 03 2020 02:46:00 GMT-0600 (hora estándar central)",
   },
   {
      id: 6,
      name: "Opal",
      subject:
         "aute culpa dolore incididunt et quis proident veniam sunt elit labore in enim tempor esse nisi amet eiusmod reprehenderit minim",
      company: "Sybixtex",
      email: "opalneal@sybixtex.com",
      phone: "(872) 577-3728",
      date: "Sun Jan 26 2020 20:24:00 GMT-0600 (hora estándar central)",
   },
   {
      id: 7,
      name: "Tiffany",
      subject:
         "occaecat officia cillum in esse adipisicing ipsum do ullamco mollit anim velit labore id eiusmod cillum exercitation fugiat et consectetur id deserunt ex sit ex consequat eiusmod nisi sit dolore laboris",
      company: "Earthpure",
      email: "tiffanyneal@earthpure.com",
      phone: "(865) 590-3494",
      date: "Wed Feb 26 2020 10:44:28 GMT-0600 (hora estándar central)",
   },
   {
      id: 8,
      name: "Krista",
      subject: "est Lorem ex aute deserunt veniam occaecat veniam qui id sit eiusmod id aute deserunt veniam proident duis ex et",
      company: "Entroflex",
      email: "kristaneal@entroflex.com",
      phone: "(930) 484-3100",
      date: "Thu Jan 16 2020 13:54:17 GMT-0600 (hora estándar central)",
   },
   {
      id: 9,
      name: "Queen",
      subject:
         "enim ad aliqua ut dolor dolore consequat irure pariatur mollit in pariatur sit reprehenderit consequat incididunt voluptate dolor commodo aliquip in amet quis magna tempor laborum duis sunt",
      company: "Datagene",
      email: "queenneal@datagene.com",
      phone: "(893) 451-2867",
      date: "Mon Jan 06 2020 09:10:14 GMT-0600 (hora estándar central)",
   },
];
